module.exports = __webpack_public_path__ + "img/garbage.5023d161.jpg";